import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatStepper } from "@angular/material";
import { Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ApiService } from "../../../services/api.service";
import { MemberAccessReason } from "../../../models/member-access-reason.model";
import * as _ from 'lodash';
import { MemberAccess } from "../../../models/member-access.model";
import { Member } from "../../../models/member.model";
import { AlertService, MessageSeverity } from "../../../services/alert.service";
import { MemberAccessActionType } from "../../../models/enums";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { ReasonService } from "../../../services/reason.service";
import * as  moment from 'moment';
import { DatePipe } from "@angular/common";

@Component({
    selector: 'edit-member-sheet',
    template: require('./edit-member-sheet.html'),
    styles: [require('./edit-member-sheet.css')],
})




  export class EditMemberSheetComponent {

    memberAccessReasons: Array<MemberAccessReason> = [];
    newMemberAccess: MemberAccess;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    member: Member;

    @ViewChild('stepper')
    matStepper: MatStepper;
    states = [];
    deliveryPreferences = [{ name: 'None', value: 0 }, { name: "Email", value: 1 }, { name: "Postal", value: 2 }]

    constructor(private changeRef: ChangeDetectorRef,
        private http: HttpClient,
        private alertService: AlertService,
        private _formBuilder: FormBuilder,
        private apiService: ApiService, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private bottomSheetRef: MatBottomSheetRef<EditMemberSheetComponent>,
        private reasonService: ReasonService,
        private datePipe : DatePipe
    ) {

        this.newMemberAccess = new MemberAccess();
        this.newMemberAccess.startTime = new Date();
        this.member = data.member;
       
        this.member.dob = EditMemberSheetComponent.toCalendarDate(this.member.dob);

        this.firstFormGroup = this._formBuilder.group({
            
        });



        this.secondFormGroup = this._formBuilder.group({
            fNControl: ['', Validators.required],
            lNControl: ['', Validators.required],
            addressControl: [],
            cityControl: [],
            zipCodeControl: [],
            usernameControl: ['', Validators.required],
            emailControl: ['', Validators.required],

            noteControl: [],
            isResolvedControl: [],
            dob: [],
            phoneControl: [],
            policyNumber: [],
            isVerified: [],
            infoVerified: [],
        });
    }

    selectReason(reasonId) {
        this.newMemberAccess.memberAccessReasonId = reasonId;
        this.firstFormGroup.setErrors(null);
        //next step
        this.matStepper.next();
        
    }

    ngOnInit() {
        this.reasonService.getAllMemberAccessReason().subscribe(r => {
            this.memberAccessReasons = r;
            this.memberAccessReasons = _.orderBy(this.memberAccessReasons, 'orderIndex');
            this.firstFormGroup.setErrors({ 'invalid': true });
            this.changeRef.detectChanges();
        })

        Observable.of(require("../../../assets/data/states_titlecase.json")).subscribe(r => {
            this.states = r;
        });


    }

    /**
     * A date of birth is a calendar date, not an instant, so it must never be moved
     * across timezones.
     *
     * The API sends it as "1959-01-01T00:00:00" with no offset, which the browser reads
     * as local midnight. Anything that then renders or serialises that instant in UTC
     * lands on the previous day for every timezone ahead of UTC -- and because the
     * shifted value is saved back, each edit walked the date back another day.
     *
     * Reading the year, month and day straight out of the string and rebuilding at local
     * midnight keeps the calendar day intact whatever the browser's timezone.
     */
    private static toCalendarDate(value: any): Date {
        if (!value) return value;
        if (value instanceof Date) return value;

        const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
        if (parts) {
            return new Date(+parts[1], +parts[2] - 1, +parts[3]);
        }

        const parsed = new Date(value);
        return isNaN(parsed.getTime()) ? value : parsed;
    }

    /**
     * Serialises the date of birth as a plain "yyyy-MM-dd" so no offset travels with it.
     * Sending a Date instead would go over the wire as toISOString(), i.e. UTC, which is
     * the other half of the same off-by-one-day problem.
     */
    private static toCalendarDateString(value: any): string {
        if (!value) return null;

        const date = EditMemberSheetComponent.toCalendarDate(value);
        if (!(date instanceof Date) || isNaN(date.getTime())) return null;

        const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
        return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
    }

    ok() {
        // Send the DOB as a bare calendar date; see toCalendarDateString above.
        const payload: any = Object.assign({}, this.member, {
            dob: EditMemberSheetComponent.toCalendarDateString(this.member.dob)
        });

        this.apiService.updateMember(payload).subscribe(r => {
            this.alertService.showMessage("", "Update Member Successfully!", MessageSeverity.success);
            this.newMemberAccess.memberAccessActionType = MemberAccessActionType.Edit;
            this.newMemberAccess.endTime = new Date();
            this.newMemberAccess.memberId = this.member.memberId;
            this.apiService.createMemberAccess(this.newMemberAccess).subscribe(res => {

            })


            this.bottomSheetRef.dismiss();
        })
    }

  }

export function reasonIdValidator(reasonId: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        console.log(reasonId);
        return reasonId == null ? { 'reasonIdValidator': 'missing Id' } : null;
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/members/edit-member-sheet/edit-member-sheet.ts